/**
 * API Endpoints for Automate Feature
 */

// Release Notes Related
export const GENERATE_RELEASE_NOTES_ENDPOINT =
	"/api/automate/generate/release-notes";
export const PUBLISH_RELEASE_ENDPOINT = "/api/automate/publish/release";

// PR Related
export const UPDATE_PR_DESCRIPTION_ENDPOINT =
	"/api/automate/update/pr-description";

// MDX Processing
export const MDX_PROCESSING_ENDPOINT = "/api/process/mdx-to-html";

/**
 * Page Routes for Automate Feature
 */
export const ROUTES = {
	GENERATE_RELEASE: "/automate/generate/release-notes",
	PUBLISH_RELEASE: "/automate/publish/release",
	UPDATE_PR: "/automate/update/pr-description",
} as const;
